import render from './render'

export default {
  name: 'Empty',

  props: {
    state: {
      type: String,
      default: 'default'
    }
  },

  render
}
